"use strict";
/*
* Created on 23.05.2019
*/

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var EntityStateFlag_1 = require("../../core/model/EntityStateFlag");

var utils_1 = require("../../core/utils");

var ProductPlacement_1 = require("../model/ProductPlacement");

var ProductPlacementConverter_1 = require("./ProductPlacementConverter");
/**
 * Implementation of {@link ProductPlacementConverter}.
 * @author ZSr
 */


var ProductPlacementConverterImpl =
/*#__PURE__*/
function (_ProductPlacementConv) {
  _inherits(ProductPlacementConverterImpl, _ProductPlacementConv);

  function ProductPlacementConverterImpl() {
    _classCallCheck(this, ProductPlacementConverterImpl);

    return _possibleConstructorReturn(this, _getPrototypeOf(ProductPlacementConverterImpl).apply(this, arguments));
  }

  _createClass(ProductPlacementConverterImpl, [{
    key: "toObject",

    /**
     * @inheritDoc
     */
    value: function toObject(source, conversions) {
      return new ProductPlacement_1.ProductPlacement(ProductPlacement_1.ProductPlacement.schema.id.valueOf(conversions.documentToClassId(source)), ProductPlacement_1.ProductPlacement.schema.externalId.valueOfField(source), ProductPlacement_1.ProductPlacement.schema.siteId.valueOf(conversions.toClassReferenceId(source.siteId)), ProductPlacement_1.ProductPlacement.schema.promotionId.valueOf(utils_1.Utils.isValueMissing(source.promotionId) ? null : conversions.toClassReferenceId(source.promotionId)), ProductPlacement_1.ProductPlacement.schema.productId.valueOf(conversions.toClassReferenceId(source.productId)), ProductPlacement_1.ProductPlacement.schema.validFrom.valueOfField(source), ProductPlacement_1.ProductPlacement.schema.validTo.valueOf(utils_1.Utils.isValueMissing(source.validTo) ? null : source.validTo), ProductPlacement_1.ProductPlacement.schema.placementTypeId.valueOf(conversions.toClassReferenceId(source.placementTypeId)), conversions.asFlagSet(source.stateFlags, EntityStateFlag_1.EntityStateFlag));
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "toDocument",
    value: function toDocument(source, conversions) {
      if (typeof source !== 'object' || source === null) {
        return null;
      }

      var result = {};
      Object.assign(result, conversions.classToDocumentId(source));
      Object.assign(result, {
        externalId: source.externalId,
        siteId: conversions.toDocumentReferenceId(source.siteId),
        promotionId: utils_1.Utils.isValueMissing(source.promotionId) ? null : conversions.toDocumentReferenceId(source.promotionId),
        productId: conversions.toDocumentReferenceId(source.productId),
        validFrom: conversions.fromDate(source.validFrom),
        validTo: utils_1.Utils.isValueMissing(source.validTo) ? null : conversions.fromDate(source.validTo),
        placementTypeId: conversions.toDocumentReferenceId(source.placementTypeId),
        stateFlags: source.stateFlags.serialize()
      });
      return result;
    }
  }]);

  return ProductPlacementConverterImpl;
}(ProductPlacementConverter_1.ProductPlacementConverter);

exports.ProductPlacementConverterImpl = ProductPlacementConverterImpl;